import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
	selector: "app-hang-tight-dialog",
	templateUrl: "./hang-tight-dialog.component.html",
	styleUrls: ["./hang-tight-dialog.component.scss"],
})
export class HangTightDialogComponent {
	title: string;
	body: string;
	constructor(@Inject(MAT_DIALOG_DATA) data: any) {
		this.title = data.title;
		this.body = data.body;
	}
}
